export default __webpack_public_path__ + "static/media/header-logo.7dcb12e9.png";